export default "__VITE_ASSET__BXsRGfx9__"